import {
  apiFetch,
  apiFetchJson,
  apiFetchWithoutBearer,
  apiUrl,
  parseApiResponse,
  readApiEnvelope,
} from '../../config/apiBase';

export async function postAuthLogin(body) {
  const res = await apiFetchWithoutBearer('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify(body ?? {}),
  });
  return readApiEnvelope(res);
}

/**
 * PASS 인증 URL 발급.
 * @param {object} body
 * @param {{ headers?: Record<string, string>, authenticated?: boolean }} [options]
 *   authenticated — true 시 apiFetch(액세스 JWT·401 리프레시). MY_PROFILE 등 로그인 필수 용도.
 */
export async function postAuthPassInit(body, options = {}) {
  const headers = { 'Content-Type': 'application/json;charset=UTF-8', ...(options.headers || {}) };
  const init = {
    method: 'POST',
    credentials: 'include',
    headers,
    body: JSON.stringify(body ?? {}),
  };
  const res = options.authenticated
    ? await apiFetch('/api/auth/pass/init', init)
    : await fetch(apiUrl('/api/auth/pass/init'), init);
  try {
    return await parseApiResponse(res, '인증 준비 중 오류가 발생했습니다.');
  } catch (e) {
    if (options.authenticated && (e?.code === 401 || res.status === 401)) {
      return { rtn: -1, message: e?.message || '로그인이 필요합니다.' };
    }
    return null;
  }
}

export async function postAuthCheckUserId(userId) {
  return apiFetchJson('/api/auth/check-userid', {
    method: 'POST',
    body: JSON.stringify({ userId }),
  });
}

export async function postAuthCheckEmail(email) {
  const data = await apiFetchJson('/api/auth/check-email', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
  return { available: data?.available === true };
}

export async function postAuthCheckInvitee(inviteUserId, signupCertToken) {
  const res = await apiFetchWithoutBearer('/api/auth/check-invitee', {
    method: 'POST',
    headers: { Authorization: `Bearer ${signupCertToken}` },
    body: JSON.stringify({ inviteUserId }),
  });
  return parseApiResponse(res, '추천인 확인에 실패했습니다.');
}

/** 가입 — HTTP 201·중복가입 분기용 envelope */
export async function postAuthSignupEnvelope(body) {
  const res = await apiFetchWithoutBearer('/api/auth/signup', {
    method: 'POST',
    body: JSON.stringify(body ?? {}),
  });
  return readApiEnvelope(res);
}

export async function postAuthFindPwCheckUserId(userId) {
  const res = await apiFetchWithoutBearer('/api/auth/find-pw/check-userid', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId }),
  });
  return readApiEnvelope(res);
}

/** 비밀번호 찾기 — 본인정보 (GET, findPwResetToken) */
export async function fetchAuthFindPwCertProfile(resetToken) {
  const res = await fetch(apiUrl('/api/auth/find-pw/cert-profile'), {
    method: 'GET',
    headers: { Authorization: `Bearer ${resetToken}` },
  });
  return parseApiResponse(res, '본인인증 정보를 불러올 수 없습니다.');
}

/** 비밀번호 찾기 — 비밀번호 변경 (findPwResetToken) */
export async function postAuthFindPwChangePassword(body, resetToken) {
  const res = await fetch(apiUrl('/api/auth/find-pw/change-password'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${resetToken}`,
    },
    body: JSON.stringify(body ?? {}),
  });
  return parseApiResponse(res, '비밀번호 변경에 실패했습니다.');
}

/** 패널가입 — PASS 본인정보 (GET, signupCertToken) */
export async function fetchAuthPassCertProfile(signupCertToken) {
  const res = await fetch(apiUrl('/api/auth/pass/cert-profile'), {
    method: 'GET',
    headers: { Authorization: `Bearer ${signupCertToken}` },
  });
  return parseApiResponse(res, '본인인증 정보를 불러올 수 없습니다.');
}

export async function postAuthFindIdSend(body) {
  const res = await apiFetchWithoutBearer('/api/auth/find-id/send', {
    method: 'POST',
    body: JSON.stringify(body ?? {}),
  });
  return readApiEnvelope(res);
}

/** 비밀번호 찾기 — 등록정보 + 임시 비밀번호 발송 */
export async function postAuthFindPwSend(body) {
  const res = await apiFetchWithoutBearer('/api/auth/find-pw/send', {
    method: 'POST',
    body: JSON.stringify(body ?? {}),
  });
  return readApiEnvelope(res);
}

/** 비밀번호 찾기 — 휴대폰 SMS 인증번호 발송 (certInfo 검증 후) */
export async function postAuthFindPwMobileCertSend(body) {
  const res = await apiFetchWithoutBearer('/api/auth/find-pw/mobile-cert/send', {
    method: 'POST',
    body: JSON.stringify(body ?? {}),
  });
  return readApiEnvelope(res);
}
